import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Detailed Business Analysis",
    description:
      "Our business development experts engage with you to precisely outline & confirm the specific scope and requirements of your business",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Strategic Consultation",
    description:
      "Once we've defined the project scope, we craft an optimized business strategy, aligning our approach with your goals for a successful outcome.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Action Plan",
    description:
      "Collaboratively, we finalize the project plan, establishing a clear timeline and scope of work that satisfies all stakeholders involved. ",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Design Prototyping",
    description:
      "dentifying your target customer groups, we carefully create wireframes, mockups, and prototypes, ensuring a design that resonates with your audience.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Website Development",
    description:
      "Our team of certified Magento website developers brings your website to life, adhering strictly to the confirmed scope and design prototypes.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Test & Ensure Quality",
    description:
      "Rigorous testing by our dedicated team ensures your website is meticulously examined for any potential bugs or issues before deployment.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our Magento Development <span>Work Cycle</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              As a leading Magento Web Development company, our methodology is
              intricately designed to tailor solutions that perfectly match your
              distinct requirements and goals. We guarantee a final product that
              not just meets but surpasses your envisioned outcomes.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
